import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=f023cf68&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=f023cf68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f023cf68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f023cf68')) {
      api.createRecord('f023cf68', component.options)
    } else {
      api.reload('f023cf68', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=f023cf68&scoped=true&", function () {
      api.rerender('f023cf68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2clHv9Pe0YCnE/JS/comp/GuestBox.vue"
export default component.exports